/**
 * @file_purpose  component created for provider section on web page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */

import React, { useState, useEffect } from 'react';
import PROVIDERS from '../../assets/images/Providers.png';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import { listProvider } from '../../redux/slices/ProviderSlice';
import Constants from '../../utility/Constants';
import { useSelector, useDispatch } from 'react-redux';
import enMessages from '../../utility/language/english.json';
import koMessages from '../../utility/language/korean.json';
import { FormattedMessage } from "react-intl";

const WebProvider = () => {

    const dispatch = useDispatch();

    const providerState = useSelector((state) => state.providerState);
    const languageState = useSelector((state) => state.languageState);
    let languageCode = languageState.active_language.language_code;

    const allMessages = {
        en: enMessages,
        ko: koMessages,
    }

    let messages = allMessages[languageCode]

    /**
  * @author Swarnali Ghosh
  * @Date_Created 06-03-2024
  * @Date_Modified 06/03/2023
  * @function async
  * @functionName loadProviderList
  * @functionPurpose this function gets provider list.
  * @functionParam {}
  * @functionSuccess Success status and message.
  * @functionError {Boolean} error is there.
  * @functionError {String} message  Description message.
  */

    async function loadProviderList() {

        GeneralService.apiGetCallRequestWithWToken(ApiURL.getProviderList).then(res => {
            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
                dispatch(listProvider(res.data))
            }
        }).catch(error => {

        })

    }

    useEffect(() => {
        window.scrollTo(0, 0);

        loadProviderList();

    }, [])
    var slidesToShow = providerState.provider_list?.length >= 5 ? 5 : providerState.provider_list.length;
    var infinite = providerState.provider_list?.length > 1 ? true : false;

    var settings = {
        dots: false,
        draggable: true,
        autoplay: false, /* this is the new line */
        autoplaySpeed: 4000,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        touchThreshold: 1000,
        rows: 3,             // 👈 number of rows
        slidesPerRow: 1,     // 👈 how many slides per row
    }

    return (
        < >
            {/* provider section start */}
            <div className="slots_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="slots_inn">
                                <div>
                                    <h6 className='d-flex align-items-center'><img src={PROVIDERS} alt="provider_img" />
                                        <FormattedMessage
                                            id="PROVIDER"
                                        />
                                    </h6>
                                    <div className='text-left mt-2'>
                                        <Link to="/provider-list">
                                            <button className='view-all-providers'>
                                                <FormattedMessage id='VIEWALLPROVIDERS' />
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                
                                {/* <div className="provider_slide" > */}
                                <Slider
                                    {...settings}
                                    className="provider_slide">

                                    {
                                        providerState.provider_list?.length > 0 ? providerState.provider_list.map((providerData, providerIndex) => (
                                            <Link to="/provider-detail" state={{ "provider_id": providerData._id, "provider_name": providerData.provider_name }} key={providerIndex}>
                                                <div >
                                                    <div className="provider_logo" style={{ marginBottom: "10px" }}>
                                                        <img src={providerData.provider_logo} alt="provider_logo" />
                                                    </div>
                                                </div>
                                            </Link>
                                        )) : ""

                                    }
                                </Slider>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* provider section end */}
        </>
    )
}

export default WebProvider
